import React, { useCallback, useEffect, useRef, useState } from 'react'
import { adminPath } from '@shared/adminPath'
import { connect } from 'react-redux'
import "./index.css"
import plusIcon from "./images/plus-icon.svg"

import _ from 'lodash'
import { closeLoader, openLoader } from '@actions/loader'
import { withRouter } from '../../utils/withRouter'
import { showToastNotification, showToastNotification as stateShowToastNotification } from '../../actions/toastNotification'
import FilterDate from '@components/FilterDate'
import FilterText from '@components/FilterText'
import { getCertificates } from '../../services/sm-api'
import CardCertificate from '../CardCertificate'
import Pagination from '../Pagination'

const OrderCertificates = ({openLoader, closeLoader, navigate}) => {

  const [certificates, setCertificates] = useState([]);
  const [paginationData, setPaginationData] = useState({
    totalPages: 1,
    totalItems: 1
  });
  const [filters, setFilters] = useState({
    page: 1,
    date_start: null,
    date_end: null,
    name: null,
    status: null,
  });

  const statusTypes = [
    {label: 'Todos', value: null},
    {label: 'Certificado Assinado', value: 'signed'},
    {label: 'Certificado Gerado', value: 'generated'},
    {label: 'Assinatura Pendente', value: 'pending'},
  ]

  const loadCertificates = useCallback(async () => {
    openLoader();

    try {
      const requestParams = {
        ...filters,
      };

      const r = await getCertificates(requestParams);
      let loadedCertificates = r.certificates;
      setPaginationData({totalPages: r.total_pages || 1, totalItems: r.total_items || loadedCertificates.length});
      setCertificates(loadedCertificates);
    } catch (e) {
      showToastNotification({
        title: 'Houve um erro',
        text: 'Não foi possível obter os certificados',
        variant: 'error'
      });
      throw e;
    } finally {
      closeLoader();
    }
  }, [filters])

  const onChangeFilter = (value, filter, e) => {
    e?.preventDefault();

    if (filter === 'date') {
      setFilters({...filters, ...value});
      return;
    }
    
    setFilters({...filters, [filter]: typeof value === 'object' && value !== null ? value[filter] : value});
  }

  const onNavigatePagination = (page) => {
    setFilters({...filters, page: page});
  }

  const goToCreate = () => navigate(adminPath(`/certificados-entrega/criar`));

  useEffect(() => {
    loadCertificates();
  }, [filters]);

  return (
    <div className="ceriticates-page">

      <div className="ceriticates-page__title-box">
        <h3>Certificados de Entrega</h3>
        <button className="button__small" onClick={() => goToCreate()}>
          Criar novo certificado &nbsp;<img src={plusIcon} />
        </button>
      </div>

      <div className="ceriticates-page__filters-box">
        <div className="ceriticates-page__filters-box__item">
          <FilterDate onChange={(value) => onChangeFilter(value, 'date')} />
        </div>
        <div className="ceriticates-page__filters-box__item">
          <FilterText
            field='term'
            onChange={(value) => onChangeFilter(value, 'term')}
            label={'Digite aqui o que você procura'}
          />
        </div>
        <div className="ceriticates-page__filters-box__item status">
          {statusTypes.map(status => (
            <a href="" onClick={(e) => onChangeFilter(status.value, 'status', e)} class={`${status.value === filters.status ? 'current' : ''}`}>{status.label}</a>
          ))}
        </div>
      </div>

      <div className="ceriticates-page__list">
        {certificates.map((certificate, index) => (
          <CardCertificate
            id={certificate.id}
            name={certificate.name}
            schoolName={certificate.school.fantasy_name}
            subordersCount={certificate.suborders_count}
            productsCount={certificate.products_count}
            status={certificate.status}
            createdDate={certificate.created_at}
          />
        ))}
      </div>

      <div className="ceriticates-page__pagination">
        <div className="ceriticates-page__pagination__total-entries">{paginationData.totalItems} Resultados</div>
        <Pagination totalPages={paginationData.totalPages} currentPage={filters.page} onSelectPage={onNavigatePagination} />
      </div>
      
    </div>
  )
}

const mapStateToProps = (state, props) => ({
  params: props.params,
  schools: state.school.schools,
  user: state.sessionReducer.user,
  order: state.order,
})

const mapDispatchToProps =  {
  openLoader,
  closeLoader,
  stateShowToastNotification,
}

const mergeProps = (stateProps, dispatchProps, props) => ({
  ...props,
  showToastNotification: (data) => dispatchProps.stateShowToastNotification(data),
  openLoader: () => dispatchProps.openLoader(),
  closeLoader: () => dispatchProps.closeLoader(),
  user: { ...stateProps.user, ...stateProps.order },
  navigate: props.navigate,
  schools: stateProps.schools,
  params: stateProps.params
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(OrderCertificates))

